import { format } from "date-fns";

import { locales } from "@/common/contexts/localization-date-context/LocalizationDateContextProvider.utils";
import { ITranslation, LanguageType } from "@/translations";

export function formatTimestamp(date: Date, t: ITranslation, language: LanguageType): string {
  return `${format(date, "E dd.MM.yyyy HH:mm", { locale: locales[language] })} ${t("common.clock")}`;
}

export default formatTimestamp;
